import { EditDevicePage } from "fleet/view/device/edit";
import { connect } from "react-redux";
import { createPromiseApiAction } from "redux-store/api-sagas";
import { getAuthUser } from "redux-store/auth";
import { EDIT_DEVICE } from "redux-store/devices/actions";
import { devicesSelector, getTagsWithIds } from "redux-store/devices/selectors";
import { networksSelector } from "redux-store/networks";
import { makeGetSelectOptions } from "redux-store/selectors";
import { currentDeviceSelector } from "redux-store/ui-state/current-device/selectors";
import { isReadonly } from "redux-store/users";
import { storesReady } from "redux-store/utils";
import { withFetchDeviceController } from "ui/fetch";

const getNetworkSelectOptions = makeGetSelectOptions();

function mapStateToProps(state, props) {
  const { deviceId } = props.match.params || {};

  const storesLoaded = storesReady(state.global.devices, state.global.networks);
  const device = currentDeviceSelector(state);
  const devices = devicesSelector(state);
  const deviceTagOptions = getTagsWithIds(devices);
  const networks = networksSelector(state);
  const networkId = device ? device.network_id : null;
  const network = networks[networkId];
  const networkOptions = getNetworkSelectOptions(networks);
  const user = getAuthUser(state);
  const readonly = isReadonly(user);

  return {
    device,
    deviceId,
    deviceTagOptions,
    network,
    networkOptions,
    readonly,
    storesLoaded,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    editDevice: (editOpts) => {
      return createPromiseApiAction(dispatch, EDIT_DEVICE, [
        editOpts.id,
        editOpts.name,
        editOpts.networkId,
        editOpts.testing,
        editOpts.location,
        editOpts.tags,
        editOpts.operateParams,
      ]);
    },
  };
}

const withFetch = withFetchDeviceController(EditDevicePage);
const ConnectedEditDevicePage = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withFetch);

export { ConnectedEditDevicePage };
